<div class="btn-group">
    <button
        [id]="'btnScale' + estimateMeasurement.order"
        type="button"
        class="btn-bx-secondary-stroked ml-1 btn-measurement-scale"
        [ngClass]="{ 'btn-highlight': !!estimateMeasurement.id_PlanMeasurement }"
        [disabled]="
            !estimateMeasurement.id ||
            !states.canChangeMeasurements ||
            states.isEstimateReadonly ||
            (viewSettings.isOverLayer && estimateMeasurement.isInTakeOff)
        "
        (click)="onTakeOff()"
        tooltip="Take off tool"
        container="body">
        <i class="ti-ruler-alt-2"></i>
    </button>

    <button
        *ngIf="viewSettings.hasCalculator"
        [id]="'btnCalculator' + estimateMeasurement.order"
        type="button"
        class="btn-bx-secondary-stroked ml-1 btn-measurement-calculator"
        [ngClass]="{ 'btn-highlight': isCalculated }"
        (click)="onCalculate()"
        [disabled]="!states.canChangeMeasurements || states.isEstimateReadonly || !estimateMeasurement.id"
        tooltip="Calculator"
        container="body">
        <i class="fa fa-calculator"></i>
    </button>

    <button
        *ngIf="!estimateMeasurement.isMeasurementShown; else hideMeasurement"
        [id]="'btnShowMeasurement' + estimateMeasurement.order"
        type="button"
        class="btn-bx-secondary-stroked ml-1 btn-measurement-toggle-show"
        [disabled]="!estimateMeasurement.id_PlanMeasurement"
        (click)="onShowMeasurement()"
        tooltip="View measurement"
        container="body">
        <i class="fa fa-eye-slash"></i>
    </button>
    <ng-template #hideMeasurement>
        <button
            [id]="'btnHideMeasurement' + estimateMeasurement.order"
            type="button"
            class="btn-bx-secondary-stroked ml-1 btn-measurement-toggle-show"
            (click)="onHideMeasurement()"
            tooltip="Hide measurement"
            container="body">
            <i class="fa fa-eye"></i>
        </button>
    </ng-template>

    <button
        [id]="'btnDelete' + estimateMeasurement.order"
        type="button"
        class="btn-bx-secondary-stroked ml-1 btn-measurement-delete"
        [disabled]="!states.canDeleteMeasurements || states.isEstimateReadonly"
        (click)="onDelete()"
        tooltip="Delete"
        container="body">
        <i class="fa fa-trash"></i>
    </button>
</div>
